module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cl":{"-":"-","refused":"Rechazado","approved":"Aprobado","review":"Revisión","with offer":"Propuesta","without offer":"Sin oferta","eligible":"Cumple","not eligible":"No cumple"}}')
  delete Component.options._Ctor
}
